export const LogosData = [
    {
        img: './logos/binance.svg'
    },
    {
        img: './logos/coinbase.svg'
    },
    {
        img: './logos/mask.svg'
    },
    {
        img: './logos/tokyo.svg'
    },
    {
        img: './logos/trust.svg'
    },
]